import {createSlice} from "@reduxjs/toolkit";
import {getError, STATE_ERROR, STATE_FETCHED, STATE_FETCHING, STATE_INITIAL} from "../../../../../_intesys/_helpers";


const initialState = {
    documentsState: STATE_INITIAL,
    documents: [],
    documentsError: null,
};

export const dashboardSlice = createSlice({
    name: "dashboard",
    initialState: initialState,
    reducers: {

        documentsCall: (state, action) => {
            state.documentsState = STATE_FETCHING;
            state.documentsError = null;
        },
        documentsFetched: (state, action) => {
            state.documentsState = STATE_FETCHED;
            state.documents = action.payload.documents;
            state.documentsError = null;
        },
        documentsError: (state, action) => {
            const error = getError(action);
            state.documentsState = STATE_ERROR;
            state.documents = undefined;
            state.documentsError = error;
        },

        startSignDone: (state, action) => {
            const {document} = action.payload;
            const documentId = document.id;
            //if found in list -> update
            state.documents = state.documents.map(entity => {
                if (entity.id === documentId) {
                    return {...entity, ...document};
                }
                return entity;
            });
        }

    }
});
